import { DefaultDeviceContract, PosTerminalStatus } from 'models'
import createDispatchAction, {
    AppThunk,
    createDispatchActionSet,
} from './base.action'
import { showErrorMessage } from './ui.action'
import posTerminalService from 'Services/api/posTerminal.service'
import createHardwareAgentService, {
    constructHardwareAgentUri,
} from '@hooks/useHardwareAgentCaller/hardwareAgent.service'

import {
    clearPermissionToken,
    clearShortLifePermission,
} from './otherModuleAction.action'

export const SET_HW_AGENT_SECURE_CONNECTION = 'SET_HW_AGENT_SECURE_CONNECTION'

export interface HwAgentSecureConnectionPayload {
    printingSecureConnection: boolean
    cfdSecureConnection: boolean
}

export const getPosTerminalActions = createDispatchActionSet<any>(
    'GET_POS_TERMINAL',
)

export const getCurrentPosTerminalActions = createDispatchActionSet<any>(
    'GET_CURRENT_POS_TERMINAL',
)

export const POS_TERMINAL_SET_OPEN_CASH_DRAWER =
    'POS_TERMINAL_SET_OPEN_CASH_DRAWER'

export const UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA =
    'UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA'

export const getCurrentPosTerminal = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getCurrentPosTerminalActions.pending())
        const terminal = (await posTerminalService.getCurrentPosTerminalInfo())
            .data
        dispatch(getCurrentPosTerminalActions.success(terminal))
        // Clear the permission override as initial
        dispatch(clearShortLifePermission())
        dispatch(clearPermissionToken())
    } catch (error) {
        dispatch(showErrorMessage(error))
    }
}

export const getCurrentPosTerminalStatusActions = createDispatchActionSet<
    PosTerminalStatus
>('GET_POS_TERMINAL_STATUS')

export const getCurrentPosTerminalStatus = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getCurrentPosTerminalStatusActions.pending())
        const res = await posTerminalService.getCurrentPosTerminalStatus()
        dispatch(getCurrentPosTerminalStatusActions.success(res.data))
    } catch (error) {
        dispatch(showErrorMessage(error))
        dispatch(getCurrentPosTerminalStatusActions.failed(error))
    }
}

export const getCurrentPosTerminalDeviceActions = createDispatchActionSet<
    DefaultDeviceContract
>('GET_POS_TERMINAL_DEVICE')

export const getCurrentPosTerminalDevice = (
    isBgProcess?: boolean,
): AppThunk => async (dispatch) => {
    try {
        if (!isBgProcess) dispatch(getCurrentPosTerminalDeviceActions.pending())
        const res = await posTerminalService.getCurrentPostTerminalDevice()
        const device = res.data

        dispatch(getCurrentPosTerminalDeviceActions.success(device))

        const printingUri = constructHardwareAgentUri(device.printingHardwareAgent)
        const cfdUri = constructHardwareAgentUri(device.cfdHardwareAgent)

        const [printingResult, cfdResult] = await Promise.allSettled([
            createHardwareAgentService(printingUri, device.printingHardwareAgent?.apiKey ?? undefined).getSecureConnect(),
            createHardwareAgentService(cfdUri, device.cfdHardwareAgent?.apiKey ?? undefined).getSecureConnect(),
        ])

        dispatch(
            createDispatchAction(SET_HW_AGENT_SECURE_CONNECTION, {
                printingSecureConnection:
                    printingResult.status === 'fulfilled'
                        ? printingResult.value.data.enabled
                        : false,
                cfdSecureConnection:
                    cfdResult.status === 'fulfilled'
                        ? cfdResult.value.data.enabled
                        : false,
            } satisfies HwAgentSecureConnectionPayload),
        )
    } catch (error) {
        dispatch(showErrorMessage(error))
        dispatch(getCurrentPosTerminalDeviceActions.failed(error))
    }
}

export const setCashDrawerOpened = (value: boolean | undefined): AppThunk => (
    dispatch,
) => {
    dispatch(createDispatchAction(POS_TERMINAL_SET_OPEN_CASH_DRAWER, value))
}
